import {useEffect,useState} from 'react';
import {AlertCircle,LoaderCircle} from 'lucide-react';
import {generationNow} from './generationClock';
import './generation.css';

export type GenerationWorker={lastSeen:string|null;checkedAt:string};
type Job={id:string;state:string;created_at:string;updated_at?:string};
const age=(now:number,date?:string|null)=>date&&Number.isFinite(Date.parse(date))?Math.max(0,now-Date.parse(date)):null;
function duration(ms:number){
 const seconds=Math.floor(ms/1000),minutes=Math.floor(seconds/60);
 return minutes?`${minutes} min. ${seconds%60} sek.`:`${seconds} sek.`;
}

export function GenerationProgress({job,worker,statusError=false,retry,compact=false}:{job:Job;worker?:GenerationWorker;statusError?:boolean;retry?:()=>void;compact?:boolean}){
 const[,tick]=useState(0);
 useEffect(()=>{const timer=setInterval(()=>tick(value=>value+1),1000);return()=>clearInterval(timer)},[]);
 const now=generationNow(worker);
 const heartbeatAge=age(now,worker?.lastSeen),stale=heartbeatAge!==null&&heartbeatAge>120000;
 const uncertain=statusError||stale||heartbeatAge===null;
 // Creation is immutable, so queue-to-running transitions never restart the timer.
 const elapsed=age(now,job.created_at);
 const title=statusError?'Vi kan ikke hente AI-status':stale?'Vi venter på nyt livstegn':job.state==='queued'?'AI-opgaven venter i kø':heartbeatAge===null?'Afventer nyt fra AI':'AI arbejder på artiklen';
 return <section className={`cap4publish-generation-progress${uncertain?' is-uncertain':''}${compact?' is-compact':''}`} aria-label="AI-status">
   {uncertain?<AlertCircle size={20} aria-hidden="true"/>:<LoaderCircle size={20} className="cap4publish-generation-spinner" aria-hidden="true"/>}
   <div className="cap4publish-generation-copy">
     <strong role="status" aria-live="polite">{title}</strong>
     <div className="cap4publish-generation-details" aria-live="off">
       {elapsed!==null&&<span>Forløbet {duration(elapsed)}</span>}
       {!compact&&<span className="cap4publish-generation-heartbeat"><i key={worker?.lastSeen} className={!uncertain?'is-fresh':''} aria-hidden="true"/>{heartbeatAge===null?'Afventer første livstegn':`Seneste livstegn for ${duration(heartbeatAge)} siden`}</span>}
     </div>
     {!compact&&uncertain&&<small>Vi kan ikke bekræfte, at opgaven stadig kører. Status kontrolleres automatisk.</small>}
   </div>
   {statusError&&retry&&<button className="text-link" onClick={retry}>Prøv igen</button>}
 </section>;
}
